import React from "react";
import "./App.css";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Router } from "./router/Router";
import AppHeader from "./common/Pages/AppHeader/AppHeader";


function App() {
  const location = useLocation();
  const hideHeaderRoutes = ["/", "/*"];


  return (
    <div className="App">
    {!hideHeaderRoutes.includes(location.pathname) && <AppHeader />}


      <>
        <Routes>
          {Router.map((el, index) => {
            let shouldRedirect = false;
            let redirectUrl = "/";
            if (el.shouldRedirect) {
              shouldRedirect = el.shouldRedirect();
            }
            if (el.redirectUrl) {
              redirectUrl = el.redirectUrl;
            }
            return (
              <Route
                key={index}
                path={el.path}
                element={
                  <ProtectedRoute
                    shouldRedirect={shouldRedirect}
                    url={redirectUrl}
                    child={el.element}
                  ></ProtectedRoute>
                }
              >
                {el.children &&
                  el.children.map((nested, id) => {
                    return (
                      <Route
                        key={id}
                        path={nested.path}
                        element={
                          <ProtectedRoute
                            shouldRedirect={shouldRedirect}
                            url={redirectUrl}
                            child={nested.element}
                          />
                        }
                      />
                    );
                  })}
              </Route>
            );
          })}
        </Routes>
      </>
    </div>
  );
}
interface ProtectedRouteProps {
  child: Element | React.JSX.Element;
  shouldRedirect: boolean;
  url: string;
  children?: any;
}

function ProtectedRoute({
  child,
  shouldRedirect,
  url = "/",
}: ProtectedRouteProps): React.JSX.Element {
  if (shouldRedirect) {
    return <Navigate to={url} />;
  }
  return <>{child as React.ReactNode}</>;
}


export default App;
